<template>
    <div>
      <h1>Welcome, {{ auth.user?.name }}</h1>
      <router-link to="/my-rides">My Rides</router-link>
    </div>
  </template>
  
  <script setup>
  import { useAuthStore } from '../store/auth';
  const auth = useAuthStore();
  </script>
  